export default "__VITE_ASSET__CqHL60Yl__"